module.exports = __webpack_public_path__ + "static/media/Ras-Al-Khaimah2.0a139b8c.jpg";